export const ExplorerResultsTabs = [
  'Response',
  'Response Headers',
  'Traces',
  'Query Plan',
  'Query Plan Preview',
  'Connectors Debugger',
] as const;
export type ExplorerResultsTab = (typeof ExplorerResultsTabs)[number];
